import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Anamnese";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/anamnese")({
  head: () => pageHead({ title: "Anamnese | Clara Camille", path: "/anamnese", noindex: true }),
  component: Page,
});
